import { handleActions } from "redux-actions";
import produce from "immer";
import { ACTIVE_MENU_ITEM } from "../constants/actionTypes";
import { headerKeys, menuTitle } from "../constants/labels";

export default handleActions(
  {
    [ACTIVE_MENU_ITEM]: produce((state, action) => {
      state[menuTitle] = action.payload;
    }),
  },
  { keys: "/", menuTitle: "" }
);